import {get} from 'lodash';

import {COLLAPSED_TREE_KEY} from '../constants';
import type {CollapsedTree} from '../types';

export const isCollapsed = (path: string[], collapsedTree?: CollapsedTree) => {
  return get(collapsedTree, [...path, COLLAPSED_TREE_KEY]);
};
